/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 */

import {
  csoCustomerOrder
  // listPayOrderExportZip,
  // isOverrunQuota,
  // listOverrunQuotaOrderPeopleForPay
} from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
// import { deepClone } from '@/tools';
import unPay from './unPay';
import paid from './paid';
import invalid from './invalid';
import paymentAudit from './paymentAudit';

import store from '@/store/index.js';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import { bankRowLabelFiled, payTypeRowLabelFiled } from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据
import incomeTaxGeneral from './incomeTaxGeneral';
import incomeTaxContinuous from './incomeTaxContinuous';

// import receiptDownload from '@/page/settlementCenter/utils/receiptDownload.js';
// import { proxyData } from '@/page/settlementCenter/utils';
// import dateFormat from '@/tools/dateFormat.js';

// const btnLoading = proxyData({
//   value: false
// });

// const downloadReceipt = {
//   name: '下载全部回单',
//   type: 'primary',
//   fn: async (app, table) => {
//     if (table.tableData.length) {
//       await receiptDownload(
//         table.searchQuery,
//         listPayOrderExportZip,
//         '',
//         `${dateFormat(new Date())}_全部下载`
//       );
//       table.searchEvent();
//     }
//   }
// };

// 批量操作
// const toPayBtn = {
//   name: '前往支付',
//   render(h, ctx) {
//     const vm = ctx.parent;
//     const handler = async () => {
//       let selection = vm.$parent.$refs.table.selection;
//       if (selection && selection.length) {
//         btnLoading.value = true;
//         try {
//           // 是否限额
//           await isRevokePeople(selection);
//           // 是否退出
//           await isOverrunQuota({
//             csoOrderIds: array2String(selection)
//           });
//           btnLoading.value = false;
//         } catch ({ data, code }) {
//           btnLoading.value = false;
//           if (+code === -1) {
//             useQuotaDialog.call(
//               vm,
//               {
//                 ids: array2String(data, ''),
//                 csoOrderIds: array2String(selection)
//               },
//               listOverrunQuotaOrderPeopleForPay
//             );
//           }
//           return;
//         }
//         vm.$xrkDialog({
//           title: '前往支付',
//           showConfirm: false,
//           showCancel: false,
//           $slots: {
//             default: vm.$createElement(require('../child/toPayOrder').default, {
//               props: {
//                 preSelection: selection
//               }
//             })
//           }
//         });
//         return false;
//       }
//       vm.$message({
//         type: 'error',
//         message: '请选择订单'
//       });
//     };
//     return (
//       <el-button
//         loading={btnLoading.value}
//         class="btn"
//         type="primary"
//         onClick={handler}
//       >
//         前往支付
//       </el-button>
//     );
//   }
// };

const example = new TableRenderClass({ fields, search });
/**
 * @description: 根据传入批次实例改为项目内容字段
 * @param {object} part 批次实例
 * @return {object} 项目实例
 */
// const setProjectTab = part => {
//   const _part = deepClone(part);
//   const searchBatchOrderNoIndex = _part.search.findIndex(
//     item => item.id === 'batchOrderNo'
//   );
//   const fieldBatchOrderNoIndex = _part.fields.findIndex(
//     item => item.prop === 'batchOrderNo'
//   );
//   _part.name = '按项目展示';
//   _part.search.splice(searchBatchOrderNoIndex, 1);
//   _part.fields.splice(
//     fieldBatchOrderNoIndex,
//     1,
//     fields['orderNo'],
//     fields['projectName'],
//     fields['batchOrderNo']
//   );
//   _part.defaultQuery = { tag: 2 };
//   return _part;
// };

// 前往支付订单
let toPayOrdersPart = example.createPart({
  list: csoCustomerOrder.noPayOrder,
  requestNow: true,
  search: ['orderNo', 'batchOrderNo', 'projectName'],
  fields: [
    {
      type: 'selection',
      width: '40px',
      reserve: true,
      selectable(row) {
        return (
          ![2, 6].includes(row.priceType) &&
          row.authStatus !== 1 &&
          row.payStatus !== 1 &&
          row.gongyeAuditStatus !== 1
        ); // 审核中、支付中 不可操作
      },
      visible: store && !!store.getters.isMaster
    },
    'orderNo',
    'batchOrderNo',
    'dingdanshengchengshijian',
    'projectName',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'zhifujiezhishijian',
    'bencixudakuanzongjine',
    'feeType',
    'remark',
    '_paymentProgress',
    'zhifuzhuangtai'
  ]
});
let toPayFeePart = example.createPart({
  list: csoCustomerOrder.needPayServicesPriceInfo,
  requestNow: true,
  fields: [
    // 'selection',
    'projectName',
    'taskDt',
    'taskAmount'
  ]
});
/*主页面入口*/
export const main = [
  unPay,
  paid,
  invalid,
  paymentAudit,
  incomeTaxGeneral,
  incomeTaxContinuous
];

/*前往支付 */
export const toPayOrders = [
  {
    name: '前往支付',
    childMenu: [toPayOrdersPart]
  }
];

export const toPayFee = [
  {
    name: '提示',
    childMenu: [toPayFeePart]
  }
];
export { editPayProject } from './editPayProject';
